<form novalidate #motorsVehicleDetailsDetailsSectionForm="ngForm">
  @if (draftLoaded$ | async) {
    <tg-row>
      <tg-col>
        <tg-row>
          <tg-col sm="12">
            <h2>
              Add details to appear in more search results
            </h2>
          </tg-col>
        </tg-row>
        <tg-row>
          <tg-col lg="4" md="6" sm="12">
            <tg-select-container label="Make">
              <select
                tgSelect
                name="make"
                (change)="publish()"
                [(ngModel)]="draftData.vehicleDetails.make"
                            [validation]="
                                validation.vehicleDetails.make
                                    | toValidator: metadata.make
                            "
                [disabled]="inputDisabled"
                >
                <option [ngValue]="null">Don't know</option>
                @for (opt of metadata.make; track opt) {
                  <option
                    [ngValue]="opt.value"
                    >
                    {{ opt.display }}
                  </option>
                }
              </select>
            </tg-select-container>
          </tg-col>
          <tg-col lg="4" md="6" sm="12">
            <tg-input-container
              label="Model"
              showRemainingCharacters="false"
              >
              <input
                tgTextInput
                size="large"
                (blur)="publish()"
                name="model"
                [(ngModel)]="draftData.vehicleDetails.model"
                            [validation]="
                                validation.vehicleDetails.model | toValidator
                            "
                [disabled]="inputDisabled"
                />
              </tg-input-container>
            </tg-col>
          </tg-row>
          <tg-row>
            <tg-col
              lg="4"
              md="6"
              sm="12"
              class="motors-vehicle-details-section__year-select"
              >
              <tg-input-container label="Year">
                <input
                  type="number"
                  tgTextInput
                  year
                  size="large"
                  (blur)="publish()"
                  name="year"
                  min="1"
                  step="1"
                  onkeypress="return !(event.charCode == 46)"
                  [(ngModel)]="draftData.vehicleDetails.year"
                            [validation]="
                                validation.vehicleDetails.year | toValidator
                            "
                  [disabled]="inputDisabled"
                  />
                </tg-input-container>
              </tg-col>
              <tg-col lg="4" md="6" sm="12">
                <tg-select-container label="Fuel type">
                  <select
                    tgSelect
                    name="fuelType"
                    (change)="publish()"
                    [(ngModel)]="draftData.vehicleDetails.fuelType"
                            [validation]="
                                validation.vehicleDetails.fuelType
                                    | toValidator: metadata.fuelType
                            "
                    [disabled]="inputDisabled"
                    >
                    <option [ngValue]="null">Don't know</option>
                    @for (opt of metadata.fuelType; track opt) {
                      <option
                        [ngValue]="opt.value"
                        >
                        {{ opt.display }}
                      </option>
                    }
                  </select>
                </tg-select-container>
              </tg-col>
            </tg-row>
            <tg-row>
              <tg-col lg="4" md="6" sm="12">
                <tg-select-container
                  label="Hull type"
                  class="hide-optional-label"
                  >
                  <select
                    tgSelect
                    name="hullType"
                    (change)="publish()"
                    [(ngModel)]="draftData.vehicleDetails.hullType"
                            [validation]="
                                validation.vehicleDetails.hullType
                                    | toValidator: metadata.hullMaterial
                            "
                    [disabled]="inputDisabled"
                    >
                    @for (opt of metadata.hullMaterial; track opt) {
                      <option
                        [ngValue]="opt.value"
                        >
                        {{ opt.display }}
                      </option>
                    }
                  </select>
                </tg-select-container>
              </tg-col>
              <tg-col lg="2" md="3" sm="6">
                <tg-input-container
                  class="hide-optional-label"
                  label="Length"
                  >
                  <input
                    decimalNumber
                    decimalPlaces="3"
                    inputmode="decimal"
                    tgTextInput
                    size="large"
                    (blur)="publish()"
                    name="length"
                    [(ngModel)]="draftData.vehicleDetails.length"
                    [validation]="lengthValidation()"
                    placeholder="0.0"
                    [disabled]="inputDisabled"
                    />
                  </tg-input-container>
                </tg-col>
                <tg-col
                  lg="2"
                  md="3"
                  sm="6"
                  class="motors-vehicle-details-section__length-unit-select"
                  >
                  <tg-select-container label="" class="hide-optional-label">
                    <select
                      tgSelect
                      name="lengthUnit"
                      (change)="publish()"
                      [(ngModel)]="draftData.vehicleDetails.lengthUnit"
                            [validation]="
                                validation.vehicleDetails.lengthUnit
                                    | toValidator
                            "
                      [disabled]="inputDisabled"
                      >
                      @for (opt of metadata.lengthUnits; track opt) {
                        <option
                          [ngValue]="opt.value"
                          >
                          {{ opt.display }}
                        </option>
                      }
                    </select>
                  </tg-select-container>
                </tg-col>
              </tg-row>
              <tg-row>
                <tg-col lg="4" md="6" sm="12">
                  <tg-input-container
                    label="Engine make"
                    showRemainingCharacters="false"
                    >
                    <input
                      tgTextInput
                      size="large"
                      (blur)="publish()"
                      name="engineMake"
                      [(ngModel)]="draftData.vehicleDetails.engineMake"
                            [validation]="
                                validation.vehicleDetails.engineMake
                                    | toValidator
                            "
                      [disabled]="inputDisabled"
                      />
                    </tg-input-container>
                  </tg-col>
                  <tg-col
                    lg="4"
                    md="6"
                    sm="12"
                    class="motors-vehicle-details-section__engine-year-select"
                    >
                    <tg-input-container label="Engine year">
                      <input
                        type="number"
                        tgTextInput
                        year
                        size="large"
                        (blur)="publish()"
                        name="engineYear"
                        min="1"
                        step="1"
                        onkeypress="return !(event.charCode == 46)"
                        [(ngModel)]="draftData.vehicleDetails.engineYear"
                            [validation]="
                                validation.vehicleDetails.engineYear
                                    | toValidator
                            "
                        [disabled]="inputDisabled"
                        />
                      </tg-input-container>
                    </tg-col>
                  </tg-row>
                  <tg-row>
                    <tg-col lg="4" md="6" sm="12">
                      <tg-form-group label="Engine size">
                        <div
                          class="motors-vehicle-details-section__engine-size-form-group-container"
                          >
                          <tg-input-container
                            class="left-content"
                            label=""
                            showLabel="false"
                            >
                            <input
                              decimalNumber
                              decimalPlaces="3"
                              inputmode="decimal"
                              tgTextInput
                              size="large"
                              (blur)="publish()"
                              name="engineSize"
                                    [(ngModel)]="
                                        draftData.vehicleDetails.engineSize
                                    "
                                    [validation]="
                                        validation.vehicleDetails.engineSize
                                            | toValidator
                                    "
                              [disabled]="inputDisabled"
                              />
                            </tg-input-container>
                            <tg-select-container
                              class="right-content"
                              label=""
                              showLabel="false"
                              >
                              <select
                                tgSelect
                                name="engineSizeUnit"
                                (change)="publish()"
                                [(ngModel)]="draftData.vehicleDetails.engineSizeUnit"
                                [validation]="engineSizeUnitValidation()"
                                [disabled]="inputDisabled">
                                @for (opt of metadata.engineSizeUnits; track opt) {
                                  <option
                                    [ngValue]="opt.value">
                                    {{ opt.display }}
                                  </option>
                                }
                              </select>
                            </tg-select-container>
                          </div>
                        </tg-form-group>
                      </tg-col>
                      <tg-col lg="4" md="6" sm="12">
                        <tg-select-container label="Engine type">
                          <select
                            tgSelect
                            name="engineType"
                            (change)="publish()"
                            [(ngModel)]="draftData.vehicleDetails.engineType"
                            [validation]="
                                validation.vehicleDetails.engineType
                                    | toValidator: metadata.engineType
                            "
                            [disabled]="inputDisabled"
                            >
                            @for (opt of metadata.engineType; track opt) {
                              <option
                                [ngValue]="opt.value"
                                >
                                {{ opt.display }}
                              </option>
                            }
                          </select>
                        </tg-select-container>
                      </tg-col>
                    </tg-row>
                    <tg-row>
                      <tg-col
                        lg="4"
                        md="6"
                        sm="12"
                        class="motors-vehicle-details-section__engine-hours-select"
                        >
                        <tg-input-container label="Engine hours">
                          <input
                            wholeNumber
                            tgTextInput
                            size="large"
                            (blur)="publish()"
                            name="engineHours"
                            [(ngModel)]="draftData.vehicleDetails.engineHours"
                            [validation]="
                                validation.vehicleDetails.engineHours
                                    | toValidator
                            "
                            placeholder="e.g. 534"
                            [disabled]="inputDisabled"
                            />
                          </tg-input-container>
                        </tg-col>
                        <tg-col lg="4" md="6" sm="12">
                          <tg-select-container
                            label="Boat location"
                            class="hide-optional-label"
                            >
                            <select
                              tgSelect
                              name="boatLocation"
                              (change)="publish()"
                              [(ngModel)]="draftData.vehicleDetails.boatLocation"
                            [validation]="
                                validation.vehicleDetails.boatLocation
                                    | toValidator: metadata.boatLocation
                            "
                              [disabled]="inputDisabled"
                              >
                              @for (opt of metadata.boatLocation; track opt) {
                                <option
                                  [ngValue]="opt.value"
                                  >
                                  {{ opt.display }}
                                </option>
                              }
                            </select>
                          </tg-select-container>
                        </tg-col>
                      </tg-row>
                      <tg-row>
                        <tg-col lg="4" md="6" sm="12">
                          <tg-checkbox-group
                            label="Condition"
                            class="hide-optional-label"
                            >
                            <tg-checkbox
                              name="isBrandNewBoat"
                              class="motors-vehicle-details-section__brand-new-boat-checkbox"
                              (change)="publish()"
                            [(ngModel)]="
                                draftData.vehicleDetails.isBrandNewBoat
                            "
                              [disabled]="inputDisabled"
                              >
                              <tg-label>
                                This is a brand new boat
                              </tg-label></tg-checkbox
                              >
                            </tg-checkbox-group>
                          </tg-col>
                        </tg-row>
                      </tg-col>
                    </tg-row>
                  }
                </form>
